import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=ec65ca0a&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec65ca0a')) {
      api.createRecord('ec65ca0a', component.options)
    } else {
      api.reload('ec65ca0a', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=ec65ca0a&", function () {
      api.rerender('ec65ca0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/product-inventory/IndexPage.vue"
export default component.exports